import { combineReducers } from 'redux';

import all from './all';
import events from './events';
import ui from './ui';

/**
 * @typedef {{
 *   all: import('./all').AuditsDataReducer,
 *   events: import('./events').AuditEventsReducer,
 *   ui: import('./ui').AuditUIReducer,
 * }} AuditsReducer
 */

export default combineReducers({
  all,
  events,
  ui,
});
